import { useState } from 'react';
import { Button } from '@mui/material';

import { PlayPreview } from '../../shared/index.js';
import CommunityPlayDetails from '../community-play-details/community-play-details.js';

interface Props {
    play: any;
    onClick?: AnyFunction;
    onRemove?: AnyFunction;
}

const CommunityPlayCard: FC<Props> = ({ play, onClick, onRemove }) => {
    const [playingPreview, setPlayingPreview] = useState(false);

    const onHover = () => {
        setPlayingPreview(true);
    };

    const onLeave = () => {
        setPlayingPreview(false);
    };

    const _onClick = (evt) => {
        if (onClick) {
            onClick(play);
        }
    };

    const _onRemove = (evt) => {
        if (onRemove) {
            evt.stopPropagation();
            onRemove(play);
        }
    };

    if (!play) {
        return null;
    }

    return (
        <div className="community-play-card card" onMouseEnter={onHover} onMouseLeave={onLeave} onClick={_onClick}>
            <PlayPreview play={play} hovered={playingPreview} doNotGenerate />
            <CommunityPlayDetails play={play} />
            {onRemove ? (
                <Button color="error" onClick={_onRemove}>
                    Remove
                </Button>
            ) : null}
        </div>
    );
};

export default CommunityPlayCard;
